import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import MediaQuery from 'react-responsive';
import { slide as Menu } from 'react-burger-menu';
//import {useSelector} from "react-redux";
import * as actionCreators from '../../redux/login/login.actions';
import { ProjectActionTypes } from '../../redux/project/project.types';
import { customShowLoadingLayer,customHideLoadingLayer,showWarningLayer, hideWarningLayer } from '../../utils/utils';
import LoginPopup from '../loginpopup/loginpopup.component';
import ChatPopup from '../chatpopup/chatpopup.component';
import { Link } from 'react-router-dom';
import { project } from '../../utils/project';
import * as actionDefinitionCreators from '../../redux/definitions/definitions.actions';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import bilgilerim from '../../assets/images/bilgilerim.svg';
import './navbarsub.styles.scss';



const NavBarSub = ({menutype,pageType,returnPage,articlesData,location,url}) => {
  const xprops = useSelector(state => state);
  const dispatch = useDispatch();
  let history = useHistory();
  const [menuOpenState, setMenuOpenState] = useState({menuOpen: false});

  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);



  const handleClose = () => {
    history.push("/home");
  }
  const handleBack = () => {
    history.push("/arama-sonuclari"+returnPage);
  }  

  const handleOpenLogin = () => dispatch(actionCreators.setFormLoginStatus(true));

  const openChatWindow = () => dispatch(actionDefinitionCreators.setFormChatStatus(true));  

  const logOut = () => dispatch(actionCreators.userLogout());
  const onWarning = (payload) => {
    dispatch({ type: ProjectActionTypes.SET_WARNING_MESSAGE, payload: payload});
  }

  const handleLogout = (event) => {
    customShowLoadingLayer();  
    onWarning({warningMessageType:'success', warningMessageText: 'Çıkış yapıldı.'});
    showWarningLayer();
    setTimeout(() => {
      logOut();
      customHideLoadingLayer();  
      hideWarningLayer();
    },3000);
  } 

  useEffect(() => {
    
    
  }, [])



  const handleStateChange = (state) => {
    setMenuOpenState({menuOpen: state.isOpen});  
  }  

  const closeMenu = () => {
    setMenuOpenState({menuOpen: false});
  }

  const toggleMenu = () => {
    setMenuOpenState(state => ({menuOpen: !state.menuOpen}));
  }  

  return(
    <React.Fragment>
      <nav id="navsubID" className="navsubbarhome">
      <MediaQuery maxWidth={768}>          
        <ul className="navsub-menu-sub-left">
        {
          pageType === "articles" ?
            <li className="navsub-item-sub-left articleMenuWrapper">
              <div id="article-menu-outer-container">            
                <Menu 
                  left 
                  isOpen={menuOpenState.menuOpen}
                  onStateChange={(state) => handleStateChange(state)}
                  width={'280px'} 
                  pageWrapId={ "mainID" } 
                  outerContainerId={ "article-menu-outer-container" }
                  customBurgerIcon={ <img src="/assets/images/menu-makale.png" alt="Blog" /> } 
                  customCrossIcon={ <img src="/assets/images/menu-toggle-off.png" alt="Gizle" /> }
                >
                  {
                    articlesData !== null && articlesData.articles.length > 0 &&
                      articlesData.articles.map((currentArticle,index) => {
                        let selected = "";
                        if (location.pathname === "/blog/" || location.pathname === "/blog"){
                          if (index === 0){
                            selected = "selected";
                          }
                        }else{
                          selected = location.pathname.includes(currentArticle.slug) ? 'selected' : '';
                        }
                        return(
                          <Link className={`bm-item ${selected}`} to={`${url}/${currentArticle.slug}`} onClick={closeMenu}>{currentArticle.title}</Link>
                        )
                      })
                  }
                </Menu>
              </div>
            </li>
          : 
            <li className="navsub-item-sub-left">&nbsp;</li>
        }
          <li className="navsub-item-sub-left">&nbsp;</li>
        </ul>
      </MediaQuery>
      <div className="navsubbarhome-container">
          <Link to="/" className="logoContainer">
            <img className="navsubbarhome-logo" src={process.env.PUBLIC_URL + '/assets/images/logo.png'} alt={project.projectName} />
          </Link>        
        </div>

      </nav>

    </React.Fragment>
  )
};


export default NavBarSub;

